import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './table-context.component.scss';
var TableContext = /** @class */ (function (_super) {
    tslib_1.__extends(TableContext, _super);
    function TableContext(element) {
        return _super.call(this, element) || this;
    }
    TableContext.prototype.init = function () { };
    TableContext.prototype.bindEvents = function () { };
    return TableContext;
}(Base));
export { TableContext };



//////////////////
// WEBPACK FOOTER
// ./components/table-context/table-context.component.ts
// module id = 529
// module chunks = 0